import React, { useEffect, useState } from 'react';

// import useSound from 'use-sound';
// import se_08 from '../../src/sound/s08_se_delay0.mp3';

export function Error35(props) {

// const [se08_se] = useSound(se_08);

useEffect(() => {
	document.getElementById('header').classList.add('is_fixed');
	document.getElementById('header').classList.add('is_behind');
}, []);

// const ShowModal = () => {
// 	props.setShowModal(true)
// }
const reloadApp = (e) => {
	e.stopPropagation();
	setTimeout(function(){
		window.location.reload();
	}, 1000);
	// se08_se();
	props.setSoundState("se08_se");
}

const [isHidden, setIsHidden] = useState(true);

useEffect(() => {
    const timer = setTimeout(() => {
		setIsHidden(false);
    }, 60000); // 1分 = 60000ミリ秒

    return () => clearTimeout(timer);
}, []);

const buttonClass = `modalBtn modalBtn01 ${isHidden ? 'is_hide' : ''}`;

return (
	<>
	<div className="modalBox_info modalBox_info02">

	<div className="modalBox_alertImg">
		<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vQ2F1dGlvbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExMzlfNDIwMykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNDMuNzEwMiAzNi41NkwyNy40NjUyIDguNDY1QzI1LjkyMDIgNS44MSAyMi4wODAyIDUuODEgMjAuNTUwMiA4LjQ2NUw0LjMwNTE5IDM2LjU2QzIuNzYwMTkgMzkuMjE1IDQuNjgwMTkgNDIuNTYgNy43NzAxOSA0Mi41Nkg0MC4yMzAyQzQzLjMwNTIgNDIuNTYgNDUuMjI1MiAzOS4yNDUgNDMuNzEwMiAzNi41NlpNMjEuNzUwMiAxNy44NEMyMS43NTAyIDE2LjU5NSAyMi43NTUyIDE1LjU5IDI0LjAwMDIgMTUuNTlDMjUuMjQ1MiAxNS41OSAyNi4yNTAyIDE2LjU5NSAyNi4yNTAyIDE3Ljg0VjI3LjA2NUMyNi4yNTAyIDI4LjMxIDI1LjI0NTIgMjkuMzE1IDI0LjAwMDIgMjkuMzE1QzIyLjc1NTIgMjkuMzE1IDIxLjc1MDIgMjguMzEgMjEuNzUwMiAyNy4wNjVWMTcuODRaTTI0LjAwMDIgMzYuOEMyMi43NTUyIDM2LjggMjEuNzUwMiAzNS43OTUgMjEuNzUwMiAzNC41NUMyMS43NTAyIDMzLjMwNSAyMi43NTUyIDMyLjMgMjQuMDAwMiAzMi4zQzI1LjI0NTIgMzIuMyAyNi4yNTAyIDMzLjMwNSAyNi4yNTAyIDM0LjU1QzI2LjI1MDIgMzUuNzk1IDI1LjI0NTIgMzYuOCAyNC4wMDAyIDM2LjhaIiBmaWxsPSIjRUIzOTU1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTEzOV80MjAzIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" alt="" width="48" height="48"/>
	</div>
	<p className="modalBox_tit alert">レジ転送エラー</p>
	<p className="modalBox_txt">レジへの転送処理が正常に終了いたしませんでした。お手数ですが、お近くの従業員にお声がけください。［35］</p>
	<div className="modalBox_img">
		<img src="/images/img_error35.svg" alt="" width="300" height="200" />
	</div>

	<button className={buttonClass} onClick={reloadApp}><span>OK</span></button>

	</div>
	</>
)

}
